import { OperationsActionType, OperationsAction } from './actions';
import { Operations } from '@card/types';
import { getListSettings, INITIAL_LIST_SETTINGS, ListSettingsType } from '../../reducers/common';

type OperationsState = {
  list: {
    data: Operations[];
    settings: ListSettingsType;
    fetching: boolean;
    error?: string;
  };
};

const initialState: OperationsState = {
  list: {
    data: [],
    settings: INITIAL_LIST_SETTINGS,
    fetching: false,
    error: undefined
  }
};

function operationsReducers(state = initialState, action: OperationsAction): OperationsState {
  switch (action.type) {
    case OperationsActionType.Fetch:
      return {
        ...state,
        list: {
          ...state.list,
          fetching: true,
          error: undefined
        }
      };
    case OperationsActionType.FetchSuccess:
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.operations,
          fetching: false,
          settings: getListSettings(action.payload.settings)
        }
      };
    case OperationsActionType.FetchError:
      return {
        ...state,
        list: {
          ...state.list,
          fetching: false,
          error: action.payload.message
        }
      };
    case OperationsActionType.GenerateReportStarted:
      return {
        ...state,
        list: {
          ...state.list,
          error: undefined,
          fetching: true
        }
      };
    case OperationsActionType.GenerateReportSuccess:
      return {
        ...state,
        list: {
          ...state.list,
          fetching: false
        }
      };
    case OperationsActionType.GenerateReportError:
      return {
        ...state,
        list: {
          ...state.list,
          fetching: false,
          error: action.payload.message
        }
      };
    default:
      return state;
  }
}

export default operationsReducers;
